import RecordView from "@/components/record/RecordView";
import { ClockIcon } from "lucide-react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { invoiceSpecificationsService } from "@/services/invoiceSpecifications";
import { getNumberFormatter } from "@/lib/utils/getNumberFormatter";
import { getRenderer } from "@/modules/projects/components/settlementsDetails/utils/getRenderer";

interface SummarySectionComponentProps {
  invoiceSpecificationId: string;
}

const SummarySectionComponent = ({
  invoiceSpecificationId,
}: SummarySectionComponentProps) => {
  const { i18n } = useTranslation();

  const numberFormatter = useMemo(
    () => getNumberFormatter(i18n.language),
    [i18n.language],
  );

  const rendererWithIcon = useMemo(
    () => getRenderer(numberFormatter),
    [numberFormatter],
  );

  const query = useQuery({
    queryKey: ["invoiceSpecification", invoiceSpecificationId],
    queryFn: () =>
      invoiceSpecificationsService.getInvoiceSpecification(
        invoiceSpecificationId,
      ),
  });

  return (
    <RecordView
      isOpen
      query={query}
      translationKey={"projectSettlementsInvoiceSpecifications"}
      header={() =>
        i18n.t("projectInvoiceSpecifications.sections.summary.header")
      }
    >
      <RecordView.Field
        name="hours"
        renderer={rendererWithIcon(<ClockIcon className="w-4 h-4" />)}
      />
      <RecordView.Field
        name="contractors_work_income"
        renderer={numberFormatter}
      />
      <RecordView.Field name="costs" renderer={numberFormatter} />
      <RecordView.Field name="additions" renderer={numberFormatter} />
      <RecordView.Field name="deductions" renderer={numberFormatter} />
      <RecordView.Field name="income" renderer={numberFormatter} />
    </RecordView>
  );
};

export const SummarySection = SummarySectionComponent;
